<template>
  <div class="container mx-auto h-full py-5">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane :label="`Pendientes`" name="pending" />
      <el-tab-pane :label="`Aprobadas`" name="approved" />
      <el-tab-pane :label="`Rechazadas`" name="rejected" />
    </el-tabs>
    <div class="flex flex-col space-y-4">
      <div class="flex flex-row space-x-8 text-base">
        <div class="flex flex-row space-x-2 border-b">
          <span class="font-semibold uppercase">total horas:</span>
          <span>{{ totalHoras }}</span>
        </div>
        <div class="flex flex-row space-x-2 border-b">
          <span class="font-semibold uppercase">total :</span>
          <span>{{ totalAmount | formatMoney }}</span>
        </div>
      </div>
      <el-row :gutter="16" class="flex items-center h-8">
        <el-col :span="10">
          <span class="font-semibold mr-2">SELECCIONADOS:</span>
          0
        </el-col>
        <el-col :span="14">
          <el-row :gutter="15">
            <el-col :span="10">
              <el-input
                v-model="searchValue"
                placeholder="Buscar"
                size="small"
                suffix-icon="el-icon-search"
                class="w-full"
                clearable
              />
            </el-col>
            <el-col :span="14">
              <el-row :gutter="15">
                <el-col :span="24">
                  <el-button
                    type="primary"
                    size="small"
                    @click="aproveSelected(true)"
                    >Aprobar seleccionadas
                  </el-button>
                  <el-button
                    type="danger"
                    size="small"
                    @click="aproveSelected(false)"
                    >Rechazar seleccionadas
                  </el-button>
                  <el-button
                    size="small"
                    icon="el-icon-printer"
                    @click="printOvertime(table.data)"
                  />
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="flex flex-col">
        <div
          class="
            flex flex-row
            border-b
            pb-1
            text-xs
            font-semibold
            text-gray-600
          "
        >
          <span
            v-for="(h, k) in table.headers"
            :key="k"
            class="flex flex-row px-1"
            :class="h.classes"
            :style="{ width: `${table.widths[k]}px` }"
            >{{ h.title }}</span
          >
        </div>
        <div
          class="h-16 flex flex-row justify-center items-center border-b"
          v-if="filteredOvertimes.length == 0"
        >
          <span class="text-xs text-gray-400">Sin Datos</span>
        </div>
        <ul class="flex flex-col text-xs" v-else>
          <li
            v-for="(v, j) in filteredOvertimes"
            class="flex flex-col border-b"
            :class="{ 'bg-gray-100': j % 2 != 0 }"
            :key="j"
          >
            <div class="flex flex-row w-full">
              <div
                @click="v.extended = !v.extended"
                class="flex flex-row items-center h-8 px-1 cursor-pointer"
                :class="table.headers[0].classes"
                :style="{ width: `${table.widths[0]}px` }"
              >
                <svg
                  v-if="v.extended"
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                  ></path>
                </svg>
                <svg
                  v-else
                  class="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1"
                    d="M9 5l7 7-7 7"
                  ></path>
                </svg>
              </div>
              <div
                class="flex flex-row w-full cursor-pointer font-semibold"
                @click="v.extended = !v.extended"
              >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[1].classes"
                  :style="{ width: `${table.widths[1]}px` }"
                  ><el-checkbox
                    v-model="v.checked"
                    :indeterminate="v.indeterminate"
                    @change="handleLevelUno(v.checked, v, v.employees)"
                /></span>
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[2].classes"
                  :style="{ width: `${table.widths[2]}px` }"
                  >{{ j + 1 }}</span
                >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[3].classes"
                  :style="{ width: `${table.widths[3]}px` }"
                  >{{ `${v.names} ${v.lastnames}` }}</span
                >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[4].classes"
                  :style="{ width: `${table.widths[4]}px` }"
                  >{{ v.paysheet.startDate | formatDate }} -
                  {{ v.paysheet.endDate | formatDate }}</span
                >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[5].classes"
                  :style="{ width: `${table.widths[5]}px` }"
                  >{{ v.paysheet.code }}</span
                >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[6].classes"
                  :style="{ width: `${table.widths[6]}px` }"
                  >{{ v.totalHours }}</span
                >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[7].classes"
                  :style="{ width: `${table.widths[7]}px` }"
                  >{{ v.totalAmount | formatMoney }}</span
                >
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[8].classes"
                  :style="{ width: `${table.widths[8]}px` }"
                ></span>
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[9].classes"
                  :style="{ width: `${table.widths[9]}px` }"
                ></span>
                <span
                  class="flex flex-row items-center h-8 px-1"
                  :class="table.headers[10].classes"
                  :style="{ width: `${table.widths[10]}px` }"
                ></span>
              </div>
            </div>
            <ul class="flex flex-col w-full" v-if="v.extended">
              <li
                class="flex flex-col w-full border-b"
                v-for="(o, i) of v.employees"
                :key="i"
              >
                <div class="flex flex-row w-full">
                  <div
                    @click="o.extended = !o.extended"
                    class="
                      flex flex-row
                      items-center
                      h-8
                      px-1
                      cursor-pointer
                      pl-2
                    "
                    :class="table.headers[0].classes"
                    :style="{ width: `${table.widths[0]}px` }"
                  >
                    <svg
                      v-if="o.extended"
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      ></path>
                    </svg>
                    <svg
                      v-else
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                        d="M9 5l7 7-7 7"
                      ></path>
                    </svg>
                  </div>
                  <div
                    class="flex flex-row w-full cursor-pointer"
                    @click="o.extended = !o.extended"
                  >
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[1].classes"
                      :style="{ width: `${table.widths[1]}px` }"
                      ><el-checkbox
                        v-model="o.checked"
                        :indeterminate="o.indeterminate"
                        @change="handleLevelDos(o.checked, o, o.overtimes, v)"
                    /></span>
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[2].classes"
                      :style="{ width: `${table.widths[2]}px` }"
                      >{{ j + 1 }}.{{ i + 1 }}</span
                    >
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[3].classes"
                      style="font-size: 10px"
                      :style="{ width: `${table.widths[3]}px` }"
                      >{{ o.code }} - ({{ o.priorCode }}) -
                      {{
                        `${o.name1} ${o.name2} ${o.lastname1} ${o.lastname2}`
                      }}</span
                    >
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[4].classes"
                      :style="{ width: `${table.widths[4]}px` }"
                    ></span>
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[5].classes"
                      :style="{ width: `${table.widths[5]}px` }"
                    ></span>
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[6].classes"
                      :style="{ width: `${table.widths[6]}px` }"
                      >{{ o.totalHours }}</span
                    >
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[7].classes"
                      :style="{ width: `${table.widths[7]}px` }"
                      >{{ o.totalAmount | formatMoney }}</span
                    >
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[8].classes"
                      :style="{ width: `${table.widths[8]}px` }"
                    ></span>
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[9].classes"
                      :style="{ width: `${table.widths[9]}px` }"
                    ></span>
                    <span
                      class="flex flex-row items-center h-8 px-1"
                      :class="table.headers[10].classes"
                      :style="{ width: `${table.widths[10]}px` }"
                    ></span>
                  </div>
                </div>
                <ul class="flex flex-col w-full" v-if="o.extended">
                  <li
                    class="flex flex-row w-full"
                    v-for="(u, i) of o.overtimes"
                    :key="i"
                  >
                    <div class="flex flex-row w-full">
                      <div
                        class="flex flex-row items-center h-8 px-1"
                        :class="table.headers[0].classes"
                        :style="{ width: `${table.widths[0]}px` }"
                      ></div>
                      <div class="flex flex-row w-full border-t bg-gray-50">
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[1].classes"
                          :style="{ width: `${table.widths[1]}px` }"
                          ><el-checkbox
                            v-model="u.checked"
                            @change="handleCheckbox(u.checked, o, v)"
                        /></span>
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[2].classes"
                          :style="{ width: `${table.widths[2]}px` }"
                        ></span>
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[3].classes"
                          :style="{ width: `${table.widths[3]}px` }"
                        ></span>
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[4].classes"
                          :style="{ width: `${table.widths[4]}px` }"
                        ></span>
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[5].classes"
                          :style="{ width: `${table.widths[5]}px` }"
                        ></span>
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[6].classes"
                          :style="{ width: `${table.widths[6]}px` }"
                          >{{ u.hours }}</span
                        >
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[7].classes"
                          :style="{ width: `${table.widths[7]}px` }"
                          >{{
                            (u.hours *
                              (o.currentSalary / (30 * 8)) *
                              u.overtimeType.factor)
                              | formatMoney
                          }}</span
                        >
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[8].classes"
                          :style="{ width: `${table.widths[8]}px` }"
                          >{{ u.overtimeType.name }}</span
                        >
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[9].classes"
                          :style="{ width: `${table.widths[9]}px` }"
                          >{{ u.date | formatDate }}</span
                        >
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[10].classes"
                          :style="{ width: `${table.widths[10]}px` }"
                          >{{ u.comment }}</span
                        >
                        <span
                          class="flex flex-row items-center h-8 px-1"
                          :class="table.headers[11].classes"
                          :style="{ width: `${table.widths[11]}px` }"
                          ><button
                            class="
                              hover:bg-red-500
                              p-1
                              rounded-full
                              hover:text-white
                            "
                            @click="deleteOvertime(u)"
                          >
                            <svg
                              class="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              ></path>
                            </svg></button
                        ></span>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <el-row :gutter="15" type="flex" justify="end" class="mt-5">
        <el-pagination
          @size-change="handleSizeChange"
          :current-page.sync="page.number"
          :page-sizes="[5, 10, 15, 25, 50, 100]"
          :page-size="page.size"
          layout="total, sizes, prev, pager, next"
          :total="overtimes.length"
          :pager-count="5"
        />
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import XLSX from "xlsx";
import { addDays, format } from "date-fns";

export default {
  name: "OvertimePaysheet",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{
          overtimes {
            id
            employee { id priorCode code name1 name2 lastname1 lastname2 currentSalary department { parentDepartment { id } } }
            hours
            overtimeType { name factor }
            date
            paysheet { paysheetType { id } code startDate endDate }
            comment
            status
          }
          paysheets { id paysheetType { id name days } month year sequence active code startDate endDate }
          overtimeTypes { id name factor }
          employees (where: { show: true }) {
            id
            name1
            name2
            name3
            lastname1
            lastname2
            lastname3
            paysheetType { id }
            code
            priorCode
            currentSalary
            oldDepartment { name }
            oldCostCenter { name }
            department {
              parentDepartment { id }
            }
            userActions { id }
            personalActions {
              startDate
              endDate
              value
              personalAction { baseSalary }
            }
          }
          users {
            id
            names
            lastnames
          }
        }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) =>
            vm.setData({
              overtimes: data.overtimes,
              paysheets: data.paysheets,
              overtimeTypes: data.overtimeTypes,
              employees: data.employees,
              users: data.users,
            })
          );
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      searchValue: "",
      activeName: "pending",
      rawOvertimes: [],
      paysheets: [],
      overtimeTypes: [],
      rawEmployees: [],
      users: [],
      table: {
        widths: [
          "30",
          "30",
          "30",
          "310",
          "158",
          "80",
          "65",
          "65",
          "125",
          "90",
          "230",
          "25",
        ],
        headers: [
          {
            title: "",
            classes: [],
          },
          {
            title: "",
            classes: [],
          },
          {
            title: "",
            classes: [],
          },
          {
            title: "Nombre completo",
            classes: [],
          },
          {
            title: "Periodo",
            classes: [],
          },
          {
            title: "Nómina",
            classes: [],
          },
          {
            title: "No. Horas",
            classes: ["justify-center"],
          },
          {
            title: "Total $",
            classes: ["justify-end"],
          },
          {
            title: "Unidad",
            classes: [],
          },
          {
            title: "Fecha",
            classes: [],
          },
          {
            title: "Observaciones",
            classes: [],
          },
          {
            title: "",
            classes: [],
          },
        ],
        data: [],
      },
      page: {
        size: 15,
        number: 1,
      },
      status: null,
    };
  },
  methods: {
    setData({ overtimes, paysheets, overtimeTypes, employees, users }) {
      this.rawOvertimes = overtimes;
      this.paysheets = paysheets;
      this.overtimeTypes = overtimeTypes;
      this.rawEmployees = employees;
      this.users = users;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    handleLevelUno(val, element, children) {
      element.indeterminate = false;
      for (const c of children) {
        c.checked = val;
        for (const o of c.overtimes) {
          o.checked = val;
        }
      }
    },
    handleLevelDos(val, element, children, parent) {
      element.indeterminate = false;
      for (const c of children) {
        c.checked = val;
      }
      if (
        parent.employees.length ==
        parent.employees.filter((o) => o.checked == val).length
      ) {
        parent.indeterminate = false;
      } else {
        parent.indeterminate = true;
      }
      parent.checked = val;
    },
    handleCheckbox(value, parent, grandpa) {
      if (
        parent.overtimes.length ==
        parent.overtimes.filter((o) => o.checked == value).length
      ) {
        parent.indeterminate = false;
      } else {
        parent.indeterminate = true;
      }
      parent.checked = value;
      if (
        grandpa.employees.length ==
        grandpa.employees.filter((o) => o.checked == value).length
      ) {
        grandpa.indeterminate = false;
      } else {
        grandpa.indeterminate = true;
      }
      grandpa.checked = value;
    },
    handleTabClick(tab, event) {
      switch (tab.name) {
        case "pending":
          this.status = null;
          break;
        case "approved":
          this.status = true;
          break;
        case "rejected":
          this.status = false;
          break;
      }
    },
    aproveSelected(status) {
      const selected = [];
      for (const supervisor of this.table.data) {
        for (const employee of supervisor.employees) {
          for (const overtime of employee.overtimes) {
            if (overtime.checked) {
              selected.push(overtime.id);
            }
          }
        }
      }
      if (selected.length == 0) {
        return this.$notify({
          title: "Error",
          message: "Debes seleccionar horas extra primero",
          type: "error",
        });
      }

      const action = status ? "aprobar" : "rechazar";
      this.$confirm(
        `¿Estás seguro que deseas ${action} las horas seleccionadas?`,
        "Confirmación",
        {
          confirmButtonText: `Si, ${action}`,
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";

              let where = "";
              for (const selection of selected) {
                where += `{ id: ${selection} }`;
              }
              axios
                .post("/", {
                  query: `
                    mutation { 
                      overtimeUpdateStatus ( 
                        where: [${where}]
                        status: ${status} 
                      )
                      { 
                        id
                        employee { id priorCode code name1 name2 lastname1 lastname2 currentSalary department { parentDepartment { id } } }
                        hours
                        overtimeType { name factor }
                        date
                        paysheet { paysheetType { id } code startDate endDate }
                        comment
                        status
                      } 
                    }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawOvertimes = data.overtimeUpdateStatus;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? `Se han ${action} las horas seleccionadas correctamente`
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = `Si, ${action}`;
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    deleteOvertime({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este registro de hora extra?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation {
                    overtimeDelete(where: {id: ${id}}){
                      id
                      employee { id priorCode code name1 name2 lastname1 lastname2 currentSalary department { parentDepartment { id } } }
                      hours
                      overtimeType { name factor }
                      date
                      paysheet { paysheetType { id } code startDate endDate }
                      comment
                      status
                    }
                  }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawOvertimes = data.overtimeDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el registro de hora extra correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    printOvertime(users) {
      const data = [];

      let index = 1;
      for (const user of users) {
        for (const employee of user.employees) {
          for (const overtime of employee.overtimes) {
            data.push([
              index,
              `${user.names} ${user.lastnames}`,
              employee.priorCode,
              employee.code,
              `${employee.lastname1} ${employee.lastname2} ${employee.name1} ${employee.name2}`,
              `${format(
                addDays(new Date(user.paysheet.startDate), 1),
                "DD/MM/YYYY"
              )} ${format(
                addDays(new Date(user.paysheet.endDate), 1),
                "DD/MM/YYYY"
              )}`,
              user.paysheet.code,
              employee.currentSalary  * 12 / 365 / 8,
              overtime.overtimeType.factor,
              overtime.hours,
              overtime.hours *
                (employee.currentSalary  * 12 / 365 / 8) *
                overtime.overtimeType.factor,
              overtime.overtimeType.name,
              format(addDays(new Date(overtime.date), 1), "DD/MM/YYYY"),
              user.paysheet.startDate.split("-")[1],
              user.paysheet.startDate.split("-")[0],
              employee.oldDepartment ? employee.oldDepartment.name : "",
              employee.oldCostCenter ? employee.oldCostCenter.name : "",
              overtime.comment,
            ]);
            index += 1;
          }
        }
      }

      const document = [
        [
          "#",
          "USUARIO",
          "CODIGO ANTIGUO",
          "CODIGO NUEVO",
          "EMPLEADO",
          "PERIODO",
          "NOMINA",
          "SALARIO/HORA",
          "FACTOR",
          "NO HORAS",
          "TOTAL $",
          "UNIDAD",
          "FECHA",
          "MES",
          "AÑO",
          "CENTRO DE COSTO ANTERIOR",
          "DEPARTAMENTO ANTERIOR",
          "OBSERVACIONES",
        ],
        [""],
        ...data,
      ];

      const sheet = XLSX.utils.aoa_to_sheet(document);
      const workbook = XLSX.utils.book_new();
      const fileName = `horas_extra_-_${format(new Date(), "YYYYMMDD_hhmmss")}`;
      XLSX.utils.book_append_sheet(workbook, sheet, fileName);
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    },
  },
  computed: {
    employees() {
      const paysheetTypes = this.paysheets.filter((p) => p.active);
      return this.rawEmployees
        .filter((e) => e.userActions != null)
        .filter((e) => {
          const paysheetTypesList = paysheetTypes.map((p) => p.paysheetType.id);
          return (
            paysheetTypesList.includes(e.paysheetType.id) &&
            e.department.parentDepartment != null
          );
        })
        .map((e) => {
          return {
            ...e,
            fullName: `${e.name1} ${e.name2} ${e.lastname1} ${e.lastname2}`,
            paysheet: paysheetTypes.find(
              (p) => p.paysheetType.id == e.paysheetType.id
            ),
          };
        });
    },
    overtimes() {
      const searchValue = this.searchValue.toLowerCase();
      const overtimes = this.employees.map((e) => {
        const overtimes = this.rawOvertimes
          .filter((o) => o.employee.id == e.id && o.status == this.status)
          .map((o) => {
            return {
              ...o,
              checked: false,
              indeterminate: false,
            };
          });
        const personalActions = e.personalActions
          .filter(
            (pa) => pa.personalAction.baseSalary && pa.endDate && pa.startDate
          )
          .filter((pa) => {
            const [psyear, psmonth, psday] = e.paysheet.startDate.split("/");
            const [peyear, pemonth, peday] = e.paysheet.endDate.split("/");
            const paysheetStartDate = new Date(`${psmonth}/${psday}/${psyear}`);
            const paysheetEndDate = new Date(`${pemonth}/${peday}/${peyear}`);
            const [pasyear, pasmonth, pasday] = pa.startDate.split("-");
            const [paeyear, paemonth, paeday] = pa.endDate.split("-");
            const startDate = new Date(`${pasmonth}/${pasday}/${pasyear}`);
            const endDate = new Date(`${paemonth}/${paeday}/${paeyear}`);

            return endDate >= paysheetStartDate && startDate <= paysheetEndDate;
          });

        const currentSalary =
          personalActions.length > 0
            ? personalActions[0].value
            : e.currentSalary;

        return {
          ...e,
          overtimes,
          checked: false,
          extended: false,
          currentSalary,
          totalHours: overtimes.reduce((a, b) => a + b.hours, 0),
          totalAmount: overtimes.reduce(
            (a, b) =>
              a +
              (
                b.hours *
                (currentSalary  * 12 / 365 / 8) *
                b.overtimeType.factor
              ).roundDecimal(),
            0
          ),
        };
      });
      const users = this.users
        .map((u) => {
          const employees = overtimes.filter(
            (o) => u.id == o.userActions.id && o.totalHours > 0
          );
          return {
            ...u,
            checked: false,
            employees,
            extended: false,
            paysheet: this.paysheets.find((p) => p.active),
            totalHours: employees.reduce(
              (a, b) =>
                a + b.overtimes.reduce((c, d) => c + d.hours, 0).roundDecimal(),
              0
            ),
            totalAmount: employees.reduce(
              (a, b) =>
                a +
                b.overtimes.reduce(
                  (c, d) =>
                    c +
                    (
                      d.hours *
                      (b.currentSalary  * 12 / 365 / 8) *
                      d.overtimeType.factor
                    ).roundDecimal(),
                  0
                ),
              0
            ),
          };
        })
        .filter((u) => u.totalHours > 0)
        .filter((d) => {
          return (
            d.employees.filter((e) => {
              return (
                e.code.toLowerCase().includes(searchValue) ||
                e.fullName.toLowerCase().includes(searchValue)
              );
            }).length > 0
          );
        })
        .map((d) => {
          if (searchValue) {
            const employees = d.employees.filter((e) => {
              return (
                e.priorCode.toLowerCase().includes(searchValue) ||
                e.code.toLowerCase().includes(searchValue) ||
                e.fullName.toLowerCase().includes(searchValue)
              );
            });
            return {
              ...d,
              extended: true,
              employees,
            };
          } else {
            return d;
          }
        });

      this.table.data = users;
      return users;
    },
    filteredOvertimes() {
      if (this.table.data.length == 0) {
        return [];
      } else {
        return this.table.data
          .sort((a, b) => {
            if (a.totalAmount > b.totalAmount) return -1;
            if (a.totalAmount < b.totalAmount) return 1;
            return 0;
          })
          .slice(
            this.page.number * this.page.size - this.page.size,
            this.page.size * this.page.number
          );
      }
    },
    totalHoras() {
      return this.table.data.reduce((a, b) => a + b.totalHours, 0);
    },
    totalAmount() {
      return this.table.data.reduce((a, b) => a + b.totalAmount, 0);
    },
  },
};
</script>
